import { EntityStatus } from '../../core/models/entity-status';
import { Enum } from '../../core/models/object-enum';

export class InvoiceStatusEnum extends Enum {
  static OPEN = new EntityStatus('open', 'PAYMENT DUE', 'warning');
  static PAID = new EntityStatus('paid', 'PAID', 'success');
  static FAILED = new EntityStatus('failed', 'PAYMENT FAILED', 'error');
}
